import React, { useState } from "react";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds,MobileUnderCalAds } from "../../Ads";
import MainCalculatorsList from "../MathCalculator/MainCalculators";
const TITLE = "Calculatrice de masse terrestre - Calculez la masse en utilisant la loi de gravitation universelle";
const DESCRIPTION =
  "Calculatrice de masse terrestre - Calculez la masse en utilisant la loi de gravitation universelle. Calculateur de physique en francais avec resultat rapide, unites claires et aide pratique pour exercices et revisions.";
const KEYWORDS =
  "earth mass calculator, calculatrice physique, formule physique, exercices de physique, calcul en ligne";
const OG_URL = "https://do-calculate.com/calculator/fr/earth-mass-calculator/";
const EarthMassCalculator = () => {
  const [gravity, setGravity] = useState(9.8);
  const [radius, setRadius] = useState(6.4e6);
  const [gConstant, setGConstant] = useState("");
  const [mass, setMass] = useState("");
  const [error, setError] = useState("");
  const calculateMass = (gravity, radius, gConstant) => {
    return (gravity * Math.pow(radius, 2)) / gConstant;
  };
  const handleCalculate = () => {
    try {
      const gravityValue = parseFloat(gravity);
      const radiusValue = parseFloat(radius);
      const gConstantValue = parseFloat(gConstant);
      if (gravity && radius && gConstant) {
        const calculatedMass = calculateMass(
          gravityValue,
          radiusValue,
          gConstantValue
        );
        setMass(calculatedMass.toExponential(2) + " kilogrammes");
        setError("");
      } else {
        throw new Error("Veuillez entrer toutes les valeurs pour calculer la masse terrestre.");
      }
    } catch (err) {
      setError(err.message);
    }
  };
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>Calculatrice de masse terrestre</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  La calculatrice de masse terrestre est un outil avancé qui vous aide à calculer la masse précise de la Terre en utilisant la loi de gravitation universelle de Newton. Cette calculatrice est basée sur un ensemble de données physiques fondamentales telles que l'accélération gravitationnelle terrestre, le rayon de la Terre et la constante de gravitation universelle. Grâce à cet outil, vous pouvez obtenir une estimation précise de la masse de notre planète, ce qui aide à améliorer votre compréhension de concepts physiques tels que la gravité et son impact sur les objets dans l'espace.
                </p>
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>Calculatrice de masse terrestre</h2>
                </div>
                <hr />
                <div dir="ltr">
                  <div>
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">
                          Accélération gravitationnelle (m/s²)
                        </label>
                      </b>
                      <input
                        type="text"
                        placeholder="9.8"
                        value={gravity}
                        onChange={(e) => setGravity(e.target.value)}
                        className="form-control"
                        style={{ width: "90%" }}
                        disabled
                      />
                    </div>
                    <br />
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">
                          Rayon terrestre (m)
                        </label>
                      </b>
                      <input
                        type="text"
                        placeholder="6.4e6"
                        value={radius}
                        onChange={(e) => setRadius(e.target.value)}
                        className="form-control"
                        style={{ width: "90%" }}
                        disabled
                      />
                    </div>
                    <br />
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">
                          Constante gravitationnelle (N·m²/kg²)
                        </label>
                      </b>
                      <input
                        type="text"
                        placeholder="6.674e-11"
                        value={gConstant}
                        onChange={(e) => setGConstant(e.target.value)}
                        className="form-control"
                        style={{ width: "90%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px" }}
                      onClick={handleCalculate}
                    >
                      Calculer
                    </button>
                  </div>
                  <br />
                  <div>
                    {error !== "" ? (
                      <p className="p-3 mb-2 bg-warning text-white">
                        Erreur : {error}
                      </p>
                    ) : (
                      mass !== "" && (
                        <p className="p-3 mb-2 bg-success text-white">
                          Masse terrestre : {mass}
                        </p>
                      )
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <br />
    </div>
  );
};
export default EarthMassCalculator;
